import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export type IRecommended_ActionSlice = {
  recommendation?: string;
  marks_by_type?: {
    "Reading Comprehension"?: number;
    "Writing"?: number;
    "Quantitative Reasoning"?: number;
    "Abstract Reasoning"?: number;
    [key: string]: number | undefined; // fallback for future categories
  };
};


export const Recommended_ActionSlice = createSlice({
  name: "Recommended_ActionSlice",
  initialState: {} as IReduxState<IRecommended_ActionSlice>,
  reducers: {
    ListRecommended_Action: (state) => {
      state.isLoading = true;
    },
    successRecommended_Action: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureRecommended_Action: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearRecommended_Action: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureRecommended_Action,
  successRecommended_Action,
  clearRecommended_Action,
  ListRecommended_Action,
} = Recommended_ActionSlice.actions;

export default Recommended_ActionSlice.reducer;
